let R2Dom = {
    Methods: {},
    Init: function () {
        document.querySelectorAll("[r2-method]").forEach((function (elem) {
            const attrMethods = elem.getAttribute("r2-method");

            attrMethods.split(" ").forEach((function (method) {
                try {
                    new R2Dom.Methods[method](elem);
                }
                catch (err) {}
            }));
        }));
    }
};

export default R2Dom;